import React, { useContext, useEffect } from 'react';
import { FaUserCog, FaUserPlus } from "react-icons/fa";
import { GoSignOut } from "react-icons/go";
import proyectoContext from '../../context/proyectos/proyectoContext';
import tareaContext from '../../context/tareas/tareaContext';
import barraprincipalContext from '../../context/barraprincipal/barraprincipalContext';
import AuthContext from '../../context/autenticacion/authContext';

const BarraPrincipal = () => {

    const proyectosContext = useContext(proyectoContext);
    const { obtenerAlturaContenedor, reiniciarProyectoState } = proyectosContext;

    const tareasContext = useContext(tareaContext);
    const { verTarea, reiniciarTareaState } = tareasContext;

    const barrapplContext = useContext(barraprincipalContext);
    const { vercuentas, cambiarComponente, verCuentas, reiniciarBotones, cerrarProyecto, reiniciarBpplState } = barrapplContext;

    const authContext = useContext(AuthContext);
    const { usuario, usuarioAutenticado, cerrarSesion } = authContext;

    const handleComponentChange = (btn1, btn2, componente) => {
        cambiarComponente(btn1, btn2, componente);
        obtenerAlturaContenedor(window.innerHeight - 56 - 108);
        cerrarProyecto();
        verTarea(false);
        verCuentas(false);
        reiniciarBotones(vercuentas);
    }

    const handleCerrarSesion = () => {
        cerrarSesion();
        reiniciarProyectoState();
        reiniciarTareaState();
        reiniciarBpplState();
    }

    useEffect(() => {
        usuarioAutenticado();
        // eslint-disable-next-line
    }, []);

    return ( 
        <header className="app-header">
            { usuario ? <p className="nombre-usuario">Hola <span>{usuario.nombre}</span></p> : null }

            <nav className="nav-principal">
                <div>
                    <button
                        disabled={ usuario ? usuario.rol !== 'Administrador' : null }
                        id="btn-admin-cuentas"
                        className={`no-active ${usuario ? usuario.rol !== 'Administrador' ? 'disabled opacity' : '' : null}`}
                        onClick={() => handleComponentChange('btn-admin-cuentas', 'btn-ver-perfil', 'crearcuenta')}
                        >
                        <FaUserPlus />
                    </button>
                </div>
                <div>
                    <button
                        href="#!"
                        id="btn-ver-perfil"
                        className="no-active"
                        onClick={() => handleComponentChange('btn-ver-perfil', 'btn-admin-cuentas', 'verperfil')}
                        >
                        <FaUserCog />
                    </button>
                </div>
                <div>
                    <button
                        onClick={() => handleCerrarSesion()}
                        className="no-active"
                    >
                        <GoSignOut />
                    </button>
                </div>
            </nav>
        </header>
    );
}
 
export default BarraPrincipal;